import React from 'react';
import { Box, Stack, Button } from '@chakra-ui/react';

const MapWithSidebarLayout = ({
    mapComponent,
    sidebarComponent,
}) => {
    return (
        <Box>
            <Stack mt="2" direction={{ base: 'column', md: 'row' }}>
                <Box
                    flex={{ md: 1, sm: 1, lg: 2 }}
                    style={{ height: "100vh" }}
                    bg="white"
                    p="2"
                    shadow="sm"
                    borderRadius="4"
                >
                    {mapComponent}
                </Box>
                <Stack
                    flex="1"
                    bg="white"
                    shadow="sm"
                    p="4"
                    spacing="2"
                    borderRadius="4"
                >
                    {sidebarComponent}
                </Stack>
            </Stack>
        </Box>
    );
}

export default MapWithSidebarLayout